import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjectProfitabilityQueryParam, vw_ProjectProfitability } from "models/project";

export interface ProjectProfitabilitySliceState {
    projects: vw_ProjectProfitability[]
    projectCount: number
    query: IProjectProfitabilityQueryParam
}

export const initialState: ProjectProfitabilitySliceState = {
    projects: [],
    projectCount: 0,
    query: {
        page: 0,
        limit: Number.MAX_SAFE_INTEGER,
        hideEmpty: true,
    } as IProjectProfitabilityQueryParam
}

const ProjectProfitabilitySliceState = createSlice({
    name: 'project-profitability-slice',
    initialState,
    reducers: {
        setProjects(state, { payload }: PayloadAction<vw_ProjectProfitability[]>) {
            state.projects = payload
        },
        setProjectCount(state, { payload }: PayloadAction<number>) {
            state.projectCount = payload
        },
        setQuery(state, { payload }: PayloadAction<IProjectProfitabilityQueryParam>) {
            state.query = payload
        }
    }
})

export const {
    setProjects,
    setProjectCount,
    setQuery
} = ProjectProfitabilitySliceState.actions

export default ProjectProfitabilitySliceState.reducer
